module.exports = __webpack_public_path__ + "static/media/user2.5ee65249.png";